import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-date-management',
  templateUrl: './date-management.component.html',
  styleUrls: ['./date-management.component.scss']
})
export class DateManagementComponent implements OnInit {
  startDate: Date;
  endDate: Date;

  constructor(public dialogRef: MatDialogRef<DateManagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
   // console.log(this.data)


    if (this.data.lifecycle) {
      //console.log(typeof (this.data.lifecycle.start))


      try {
        this.startDate = this.data.lifecycle.start.toDate();
        this.endDate = this.data.lifecycle.end.toDate();
      } catch (err) {
        this.startDate = this.data.lifecycle.start;
        this.endDate = this.data.lifecycle.end;
      }

    }

  }

  setDate() {
    //console.log(this.startDate, this.endDate)


    this.data.lifecycle = { start: this.startDate, end: this.endDate }

    this.dialogRef.close(this.data);
  }

  close() {
    this.dialogRef.close();
  }
}
